import logger from 'utils/logger.util';

const L = logger('parsfixed');

const FRACTION_DIGITS = 2;

const parsfixed = (string) => {
  try {
    return parseFloat(string).toFixed(FRACTION_DIGITS);
  } catch (e) {
    return L.warn('()', e, 'returning same string:', string);
  }
};

// noinspection JSUnusedGlobalSymbols
export default parsfixed;
